import React from 'react'
import {Spinner} from "react-bootstrap"
import './CargandoDatosLoader.css'

const CargandoDatosLoader = function(props){
  return <>
    { props.cargando ?
      (
        <div className='comp-cargando-datos-loader'>
          <div style={{display: 'flex'}}>
            <Spinner animation="border" variant="primary" />
            <div className='texto-obteniendo-datos text-primary'>Obteniendo Datos</div>
          </div>
        </div>
      )
      : props.children
    }

  </>
}

export default CargandoDatosLoader